var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"badge text-white",class:_vm.variant},[_vm._v("\r\n    "+_vm._s(_vm.row.status_fa)+"\r\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }